import { render, staticRenderFns } from "./repositoryDetails.vue?vue&type=template&id=74f8433e&scoped=true&"
import script from "./repositoryDetails.vue?vue&type=script&lang=js&"
export * from "./repositoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f8433e",
  null
  
)

export default component.exports